<template>
	<div class="header">
		<div class="logo">
			<img src="@/assets/images/logo.png"/>
		</div>
		<div class="nav">
			<router-link to="/">
				<span>首页</span>
				<i></i>
			</router-link>
			<!-- <router-link to="/news">
				<span>优选资讯</span>
				<i></i>
			</router-link> -->
			<router-link to="/about">
				<span>关于我们</span>
				<i></i>
			</router-link>
			<router-link to="/contact">
				<span>联系我们</span>
				<i></i>
			</router-link>
			<router-link to="/download">
				<span>下载APP</span>
				<i></i>
			</router-link>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {

		}
	},
	created() {},
	mounted() {},
	computed: {},
	methods: {},
	components: {}
}
</script>

<style scoped lang="less">
.header {
	padding:0 60px 0 60px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	position: fixed;
	z-index: 9;
	left: 0;
	right: 0;
	top: 0;
	background: #fff;
	height: 80px;
	.logo{
		img{
			width:auto;
			height: 33px;
		}
	}
	.nav{
		a{
			font-size: 16px;
			font-weight: bolder;
			color: #313131;
			margin-left: 80px;
			position: relative;
			&.router-link-exact-active{
				color: #FF4F6A;
				i{
					position: absolute;
					left: 0;
					right: 0;
					bottom: -28px;
					height: 4px;
					background: #FF4F6A;
				}
			}
			
		}
	}
}
</style>